import img1 from '../../images/svg-1.svg'
import img2 from '../../images/svg-2.svg'
import img5 from '../../images/svg-5.svg'


export const homeObjOne = {
    id:'about',
    lightBg:false,
    lightText:true,
    lightTextDesc:true,
    topLine:'What Tech Phoenix Offers ?',
    headline:'All New Releases from the field of Sci-Tech ',
    description:'Your wait is finally Over. Get all Information about new Technologies at your fingertips. Get to Learn  and Implement them too. join now',
    buttonLabel: 'Join Now',
    imgStart:false,
    img:img1,
    alt:'Circle',
    dark:true,
    primary:true,
    darkText:false
}


export const homeObjTwo = {
    id:'discover',
    lightBg:true,
    lightText:false,
    lightTextDesc:false,
    topLine:'Keep Exploring !',
    headline:'Get free access to all the contents from Tech-Phoenix',
    description:'Ever Wondered how the world would look like without all the technologies of the latest norm?  Well, It is hard to imagine. So, why would you be left alone ? Become a Phoenix and lets explore a whole new set of Ideas that fulfills your Dreams. ',
    buttonLabel: 'Learn More',
    imgStart:true,
    img:img2,
    alt:'tree',
    dark:false,
    primary:false,
    darkText:true
}


export const homeObjThree = {
    id:'signup',
    lightBg:true,
    lightText:false,
    lightTextDesc:false,
    topLine:'Become a Phoenix Member',
    headline:'The World is moving Ahead each day. Are you ? ',
    description:'In Tech-Phoenix, not only you will be provided with consistant updates about all new ways of making new Models from Scratch, but also you will be able to devlop many things independently and build your Portfolio too. So, are you ready for leaping into the future and becoming Unstoppable ??',
    buttonLabel:'Lets do it',
    imgStart:false,
    img:img5,
    alt:'Car',
    dark:false,
    primary:false,
    darkText:true
}






